import React, { useState, useEffect } from 'react';
import './common.css';
import './Login.css';
import StickyHeader from './StickyHeader';
import { FaFileCode, FaTimesCircle } from 'react-icons/fa';
import {Button} from 'evergreen-ui';
import { ClipLoader } from 'react-spinners';
import { IterationCcw } from 'lucide-react';
const JSONUploader = () => {
  const [fileArray, setFileArray] = useState([]); // file names
  const [jsonData, setJsonData] = useState([]);   // full file contents
  const [isDragging, setIsDragging] = useState(false);
  const [industryList, setIndustryList] = useState(null);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [loader, setShowLoader] = useState(false);

useEffect(()=>{
    fetchIndustries();
},[]);

const fetchIndustries = async () =>{
    setShowLoader(true);
    try{
        const response = await fetch('https://promo.myservicecircle.app/webservice/indlist.php',{
            method:'POST',
            headers:{
                'Content-Type':'application/json'
            },
            body:JSON.stringify({id:1})
        });
        const responseData = await response.json();        
        setIndustryList(responseData);
    }catch(error){
        alert(error);
    }finally{
        setShowLoader(false);
    }
}

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files);
    const jsonFiles = files.filter(file => file.name.endsWith('.json'));

    if (jsonFiles.length + fileArray.length > 25) {
      alert('You can only upload up to 25 JSON files.');
      return;
    }

    jsonFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const content = event.target.result;
        console.log(`Raw content from ${file.name}:`, content); // <-- Add this

        try {
            const cleanContent = content.replace(/^\uFEFF/, '');
            const parsed = JSON.parse(cleanContent);

            // Optionally validate structure
            if (!Array.isArray(parsed)) {
            throw new Error("JSON root is not an array");
            }

            setFileArray(prev => [...prev, file.name]);
            setJsonData(prev => [...prev, { name: file.name, content: parsed }]);
        } catch (err) {
            console.error("Parse error:", err); // <-- Add this
            alert(`Invalid JSON in file: ${file.name}`);
        }
        };

      reader.readAsText(file);
    });
  };

  const removeFile = (filename) => {
    setFileArray(prev => prev.filter(name => name !== filename));
    setJsonData(prev => prev.filter(item => item.name !== filename));
  };

  const handleRowDelete = (fileName, rowIndex) => {
  setJsonData(prevData =>
    prevData.map(file =>
      file.name === fileName
        ? { ...file, content: file.content.filter((_, i) => i !== rowIndex) }
        : file
    )
  );
};

const submitData = async (index) =>{    
  
    const contentToSend = jsonData[index].content;
    if(!selectedIndustry){
      alert("Please select the industry");
      return;
    }
    setShowLoader(true);
    try{
      const dataString = {
        ind_id:selectedIndustry.id,
        list:contentToSend
      }

      const response = await fetch('https://promo.myservicecircle.app/webservice/uploadJson.php',{
        method:'POST',
        headers:{
          'Content-Type':'application/json'
        },
        body:JSON.stringify(dataString)
      });

      const responseData = await response.json();
      if(responseData.success && responseData.success == 1){
       
        removeFile(jsonData[index].name);
        alert(`Success!! rows added: ${responseData.inserted}`);
      }else{
        alert('Something went wrong');
      }
    }catch(error){

    }finally{
      setShowLoader(false);
    }

}

  return (
    <>
      <StickyHeader />
      <div style={{ justifyContent: 'flex-start', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
       {loader && (
        <div style={{
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.35)',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10,
            top: 0,
            left: 0,
            position: 'fixed',
            display: 'flex' 
        }}>
            <ClipLoader color='#FCC100' />
        </div>
        )}
        {selectedIndustry ? 
            <>
            <div style={{width:'100%',padding:10,backgroundColor:'#fff',display:'flex',justifyContent:'center',alignItems:'center',gap:20}}>
                <h3>Selected Industry : {selectedIndustry.name}</h3>
                <Button style={{backgroundColor:'#444',color:'#fff',borderColor:'#444'}} onClick={()=>setSelectedIndustry(null)}>Reset</Button>
            </div>
            <div onDrop={handleDrop}onDragOver={(e) => {e.preventDefault();setIsDragging(true);}} onDragLeave={() => setIsDragging(false)}style={{width: '80%',
            display: 'flex',borderWidth: 3,borderColor: isDragging ? '#00b894' : '#444',borderStyle: 'dotted',borderRadius: 10,padding: 20,height: 200,marginTop: '5%',textAlign: 'center',justifyContent: 'center',alignItems: 'center',backgroundColor: isDragging ? '#dfffe0' : '#f9f9f9',flexDirection: 'column',transition: 'all 0.3s ease',overflowY: 'auto'}}>
          {fileArray.length < 1 ? (
            <h3>Drag and drop up to 25 JSON files in the box below</h3>
          ) : (
            <>
              <h4>Uploaded Files:</h4>
              {fileArray.map((file, idx) => (
                <div key={idx} style={{display: 'flex',alignItems: 'center',gap: 8,margin: 4,background: '#ecf0f1',padding: '5px 10px',borderRadius: 5,width: '70%',justifyContent: 'space-between'}}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <FaFileCode color="#2d3436" />
                    <span style={{ fontSize: 14 }}>{file}</span>
                  </div>
                  <FaTimesCircle onClick={() => removeFile(file)} color="#e74c3c" style={{ cursor: 'pointer' }}title="Remove"/>
                </div>
              ))}
            </>
          )}
        </div>
       <div style={{ width: '90%', marginTop: 30 }}>
            {jsonData.map((file, fileIndex) => (
                <div key={fileIndex} style={{ marginBottom: 40 }}>
                <div style={{width:'100%',display:'flex',justifyContent:'center',alignItems:'center',padding:10,gap:10,backgroundColor:'#fff'}}>                
                    <h4 style={{ marginBottom: 10, color: '#000' }}>{file.name}</h4>
                    <Button onClick={()=>submitData(fileIndex)}>Submit {file.name} to database</Button>
                </div>
                <div style={{
                    border: '1px solid #ccc',
                    borderRadius: 8,
                    overflowX: 'auto',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
                }}>
                    <table style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    fontSize: 14,
                    backgroundColor: '#fff'
                    }}>
                    <thead style={{ backgroundColor: '#f5f6fa' }}>
                    <tr>
                        <th style={{ padding: 10, borderBottom: '1px solid #ccc', textAlign: 'left' }}>Name</th>
                        <th style={{ padding: 10, borderBottom: '1px solid #ccc', textAlign: 'left' }}>Email</th>
                        <th style={{ padding: 10, borderBottom: '1px solid #ccc', textAlign: 'center' }}>Action</th>
                    </tr>
                    </thead>

                    <tbody>
                    {file.content.map((entry, idx) => (
                        <tr key={idx}>
                        <td style={{ padding: 10, borderBottom: '1px solid #eee' }}>{entry.name}</td>
                        <td style={{ padding: 10, borderBottom: '1px solid #eee' }}>{entry.email}</td>
                        <td style={{ padding: 10, borderBottom: '1px solid #eee', textAlign: 'center' }}>
                            <FaTimesCircle
                            onClick={() => handleRowDelete(file.name, idx)}
                            color="#e74c3c"
                            style={{ cursor: 'pointer' }}
                            title="Delete Row"
                            />
                        </td>
                        </tr>
                    ))}
                    </tbody>

                    </table>
                </div>
                </div>
            ))}
            </div>
            </>
            :
            <>
            <h3>Select the industry</h3>
            <div style={{display:'flex',padding:10,maxHeight:50,borderRadius:10,borderWidth:1,borderColor:'#444',backgroundColor:'#fff',justifyContent:'center',alignItems:'center',gap:10,flexWrap:'wrap'}}>
                {industryList && industryList.map((item,index)=>(
                    <div className='industryBlock' key={index} style={{padding:10,backgroundColor:selectedIndustry ? '#FCC100':'#444',borderRadius:10,color:'#fff',justifyContent:'center',alignItems:'center',display:'flex',cursor:'pointer'}} onClick={()=>setSelectedIndustry(item)}>
                        <h5>{item.name}</h5>
                    </div>
                ))}
            </div>
            </>
        }
        

      </div>
    </>
  );
};

export default JSONUploader;
